import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, messageErreur } from "@/lib/api";
import { formatEuros } from "@/lib/format";

const ETATS = { a_venir: "À venir", due: "Due", facturee: "Facturée", payee: "Payée", en_retard: "En retard" };

export default function Commissions() {
  const [d, setD] = useState(null);
  const charger = useCallback(() => api.get("/commissions").then((r) => setD(r.data)).catch((e) => toast.error(messageErreur(e))), []);
  useEffect(() => { charger(); }, [charger]);
  const op = (f, operation) => api.patch(`/commissions/${f.id}`, { operation }).then(() => { toast.success(operation === "facturer" ? "Commission facturée." : "Commission payée."); charger(); }).catch((e) => toast.error(messageErreur(e)));
  if (!d) return <p className="at-muted">Chargement…</p>;
  return (
    <div className="space-y-4 min-w-0" data-testid="commissions-page">
      <div><h2 className="text-base md:text-lg font-bold">Commissions</h2><p className="text-sm at-muted">Réservé au Dirigeant. Due à « Client satisfait », en retard 30 jours après la facture.</p></div>
      {d.length === 0 && <p className="at-muted">Aucune commission.</p>}
      {d.map((g) => (
        <section key={g.partenaire_id} className="at-card p-4 space-y-3" data-testid={`commissions-${g.partenaire_id}`}>
          <p className="font-bold text-lg">{g.nom}</p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm">
            {["due", "facturee", "payee", "en_retard"].map((k) => <div key={k} className="at-soft p-2" style={k === "en_retard" && g[k] ? { color: "var(--danger)" } : undefined}><p className="text-xs at-muted">{ETATS[k]}</p><p className="font-bold" data-testid={`commissions-${g.partenaire_id}-${k}`}>{formatEuros(g[k])}</p></div>)}
          </div>
          {g.dossiers.map((f) => (
            <div key={f.id} className="flex items-center justify-between gap-2" data-testid={`commission-row-${f.id}`}>
              <Link to={`/fiches/${f.id}`} className="min-w-0 min-h-[44px] flex flex-col justify-center"><span className="font-semibold truncate">{f.nom}</span><span className="text-xs at-muted">{formatEuros(f.commission)} · {ETATS[f.etat]}</span></Link>
              {f.etat === "due" && <button type="button" onClick={() => op(f, "facturer")} className="at-btn at-btn-ghost shrink-0 !px-3 text-sm" data-testid={`commission-invoice-${f.id}`}>Facturer</button>}
              {["facturee", "en_retard"].includes(f.etat) && <button type="button" onClick={() => op(f, "payer")} className="at-btn at-btn-primary shrink-0 !px-3 text-sm" data-testid={`commission-pay-${f.id}`}>Payée</button>}
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
